//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class WealthMappingClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    propelleWaitlistEndpointsPushCustomersToHubspot(request: PropelleWaitlistEndpointsPushCustomersToHubspot_Request): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/push-multiple-to-hubspot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPropelleWaitlistEndpointsPushCustomersToHubspot(_response);
        });
    }

    protected processPropelleWaitlistEndpointsPushCustomersToHubspot(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    calculateFutureValue(request: CalculateFutureValue_Request): Promise<CalculateFutureValue_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/calculate-future-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateFutureValue(_response);
        });
    }

    protected processCalculateFutureValue(response: Response): Promise<CalculateFutureValue_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateFutureValue_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateFutureValue_Response>(null as any);
    }

    /**
     * @return Success
     */
    calculateOwnedFutureValue(request: CalculateFutureValue_Request): Promise<CalculateFutureValue_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/calculate-owned-future-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateOwnedFutureValue(_response);
        });
    }

    protected processCalculateOwnedFutureValue(response: Response): Promise<CalculateFutureValue_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateFutureValue_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateFutureValue_Response>(null as any);
    }

    /**
     * @return Success
     */
    createOwnedWealthPicture(request: CreateWealthPicture_Request): Promise<CreateWealthPicture_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/owned-wealth-picture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOwnedWealthPicture(_response);
        });
    }

    protected processCreateOwnedWealthPicture(response: Response): Promise<CreateWealthPicture_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWealthPicture_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateWealthPicture_Response>(null as any);
    }

    /**
     * @return Success
     */
    createWealthPicture(request: CreateWealthPicture_Request): Promise<CreateWealthPicture_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/wealth-picture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWealthPicture(_response);
        });
    }

    protected processCreateWealthPicture(response: Response): Promise<CreateWealthPicture_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWealthPicture_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateWealthPicture_Response>(null as any);
    }

    /**
     * @return Success
     */
    deleteCustomer(userId: string | null): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCustomer(_response);
        });
    }

    protected processDeleteCustomer(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getPreviousWealthPicture(): Promise<GetPreviousWealthPicture_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/previous-wealth-picture";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreviousWealthPicture(_response);
        });
    }

    protected processGetPreviousWealthPicture(response: Response): Promise<GetPreviousWealthPicture_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPreviousWealthPicture_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPreviousWealthPicture_Response>(null as any);
    }

    /**
     * Get the user's progress for creating tools
     * @return Success
     */
    getToolProgress(): Promise<GetToolProgress_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/tools/progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetToolProgress(_response);
        });
    }

    protected processGetToolProgress(response: Response): Promise<GetToolProgress_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetToolProgress_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetToolProgress_Response>(null as any);
    }

    /**
     * @return Success
     */
    getWealthMappingOverview(): Promise<GetWealthMappingOverview_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWealthMappingOverview(_response);
        });
    }

    protected processGetWealthMappingOverview(response: Response): Promise<GetWealthMappingOverview_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWealthMappingOverview_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWealthMappingOverview_Response>(null as any);
    }

    /**
     * Create a note for a user (anonymous endpoint)
     * @return Success
     */
    notesCreateUserNote(root: NotesCreateUserNote_Request_Root): Promise<NotesCreateUserNote_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotesCreateUserNote(_response);
        });
    }

    protected processNotesCreateUserNote(response: Response): Promise<NotesCreateUserNote_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotesCreateUserNote_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotesCreateUserNote_Response>(null as any);
    }

    /**
     * Get all notes for the authenticated user
     * @return Success
     */
    notesGetUserNotes(includeRead: boolean): Promise<NotesGetUserNotes_Response_Root> {
        let url_ = this.baseUrl + "/api/wealth-mapping/notes?";
        if (includeRead === undefined || includeRead === null)
            throw new Error("The parameter 'includeRead' must be defined and cannot be null.");
        else
            url_ += "IncludeRead=" + encodeURIComponent("" + includeRead) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotesGetUserNotes(_response);
        });
    }

    protected processNotesGetUserNotes(response: Response): Promise<NotesGetUserNotes_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotesGetUserNotes_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotesGetUserNotes_Response_Root>(null as any);
    }

    /**
     * Mark a note as read for the authenticated user
     * @return Success
     */
    notesMarkNoteAsRead(request: NotesMarkNoteAsRead_Request, noteId: string): Promise<NotesMarkNoteAsRead_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/notes/{noteId}/read";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotesMarkNoteAsRead(_response);
        });
    }

    protected processNotesMarkNoteAsRead(response: Response): Promise<NotesMarkNoteAsRead_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotesMarkNoteAsRead_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotesMarkNoteAsRead_Response>(null as any);
    }

    /**
     * Create or update a user's investment plan
     * @return Success
     */
    investmentPlanToolAddUserInvestmentPlan(root: InvestmentPlanToolAddUserInvestmentPlan_Request_Root): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/investment-plans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvestmentPlanToolAddUserInvestmentPlan(_response);
        });
    }

    protected processInvestmentPlanToolAddUserInvestmentPlan(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get all available investment plans for user
     * @return Success
     */
    investmentPlanToolGetUserInvestmentPlans(): Promise<InvestmentPlanToolGetUserInvestmentPlans_Response_Root> {
        let url_ = this.baseUrl + "/api/wealth-mapping/investment-plans";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvestmentPlanToolGetUserInvestmentPlans(_response);
        });
    }

    protected processInvestmentPlanToolGetUserInvestmentPlans(response: Response): Promise<InvestmentPlanToolGetUserInvestmentPlans_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentPlanToolGetUserInvestmentPlans_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestmentPlanToolGetUserInvestmentPlans_Response_Root>(null as any);
    }

    /**
     * Get an investment plan by ID
     * @return Success
     */
    investmentPlanToolGetUserInvestmentPlanById(investmentPlanId: string): Promise<InvestmentPlanToolGetUserInvestmentPlanById_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/investment-plans/{InvestmentPlanId}";
        if (investmentPlanId === undefined || investmentPlanId === null)
            throw new Error("The parameter 'investmentPlanId' must be defined.");
        url_ = url_.replace("{InvestmentPlanId}", encodeURIComponent("" + investmentPlanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvestmentPlanToolGetUserInvestmentPlanById(_response);
        });
    }

    protected processInvestmentPlanToolGetUserInvestmentPlanById(response: Response): Promise<InvestmentPlanToolGetUserInvestmentPlanById_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentPlanToolGetUserInvestmentPlanById_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestmentPlanToolGetUserInvestmentPlanById_Response>(null as any);
    }

    /**
     * Update an investment plan by ID
     * @return Success
     */
    investmentPlanToolUpdateUserInvestmentPlan_Request(root: InvestmentPlanToolUpdateUserInvestmentPlan_Request_Root, investmentPlanId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/investment-plans/{InvestmentPlanId}";
        if (investmentPlanId === undefined || investmentPlanId === null)
            throw new Error("The parameter 'investmentPlanId' must be defined.");
        url_ = url_.replace("{InvestmentPlanId}", encodeURIComponent("" + investmentPlanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvestmentPlanToolUpdateUserInvestmentPlan_Request(_response);
        });
    }

    protected processInvestmentPlanToolUpdateUserInvestmentPlan_Request(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Create or update a financial goal for user
     * @return Success
     */
    financialGoalToolAddUserFinancialGoal(root: FinancialGoalToolAddUserFinancialGoal_Request_Root): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/financial-goals/user-goals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinancialGoalToolAddUserFinancialGoal(_response);
        });
    }

    protected processFinancialGoalToolAddUserFinancialGoal(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get all available financial goals for user
     * @return Success
     */
    financialGoalToolGetUserFinancialGoals(): Promise<FinancialGoalToolGetUserFinancialGoals_Response_Root> {
        let url_ = this.baseUrl + "/api/wealth-mapping/financial-goals/user-goals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinancialGoalToolGetUserFinancialGoals(_response);
        });
    }

    protected processFinancialGoalToolGetUserFinancialGoals(response: Response): Promise<FinancialGoalToolGetUserFinancialGoals_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialGoalToolGetUserFinancialGoals_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialGoalToolGetUserFinancialGoals_Response_Root>(null as any);
    }

    /**
     * Delete a user's financial goal
     * @return Success
     */
    financialGoalToolDeleteUserFinancialGoal(userGoalId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/financial-goals/user-goals/{UserGoalId}";
        if (userGoalId === undefined || userGoalId === null)
            throw new Error("The parameter 'userGoalId' must be defined.");
        url_ = url_.replace("{UserGoalId}", encodeURIComponent("" + userGoalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinancialGoalToolDeleteUserFinancialGoal(_response);
        });
    }

    protected processFinancialGoalToolDeleteUserFinancialGoal(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get a user's financial goal by ID
     * @return Success
     */
    financialGoalToolGetUserFinancialGoalById(userGoalId: string): Promise<FinancialGoalToolGetUserFinancialGoalById_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/financial-goals/user-goals/{UserGoalId}";
        if (userGoalId === undefined || userGoalId === null)
            throw new Error("The parameter 'userGoalId' must be defined.");
        url_ = url_.replace("{UserGoalId}", encodeURIComponent("" + userGoalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinancialGoalToolGetUserFinancialGoalById(_response);
        });
    }

    protected processFinancialGoalToolGetUserFinancialGoalById(response: Response): Promise<FinancialGoalToolGetUserFinancialGoalById_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialGoalToolGetUserFinancialGoalById_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialGoalToolGetUserFinancialGoalById_Response>(null as any);
    }

    /**
     * Update a financial goal for user
     * @return Success
     */
    financialGoalToolUpdateUserFinancialGoal(root: FinancialGoalToolUpdateUserFinancialGoal_Request_Root, userGoalId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/financial-goals/user-goals/{UserGoalId}";
        if (userGoalId === undefined || userGoalId === null)
            throw new Error("The parameter 'userGoalId' must be defined.");
        url_ = url_.replace("{UserGoalId}", encodeURIComponent("" + userGoalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinancialGoalToolUpdateUserFinancialGoal(_response);
        });
    }

    protected processFinancialGoalToolUpdateUserFinancialGoal(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get all available financial goals
     * @return Success
     */
    financialGoalToolGetFinancialGoalsList(): Promise<FinancialGoalToolGetFinancialGoalsList_Response_Root> {
        let url_ = this.baseUrl + "/api/wealth-mapping/financial-goals/goals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinancialGoalToolGetFinancialGoalsList(_response);
        });
    }

    protected processFinancialGoalToolGetFinancialGoalsList(response: Response): Promise<FinancialGoalToolGetFinancialGoalsList_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialGoalToolGetFinancialGoalsList_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialGoalToolGetFinancialGoalsList_Response_Root>(null as any);
    }
}

export class PropelleWaitlistEndpointsPushCustomersToHubspot_Request implements IPropelleWaitlistEndpointsPushCustomersToHubspot_Request {
    anonymousWealthPictureIds?: string[] | undefined;

    constructor(data?: IPropelleWaitlistEndpointsPushCustomersToHubspot_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["anonymousWealthPictureIds"])) {
                this.anonymousWealthPictureIds = [] as any;
                for (let item of _data["anonymousWealthPictureIds"])
                    this.anonymousWealthPictureIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PropelleWaitlistEndpointsPushCustomersToHubspot_Request {
        data = typeof data === 'object' ? data : {};
        let result = new PropelleWaitlistEndpointsPushCustomersToHubspot_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.anonymousWealthPictureIds)) {
            data["anonymousWealthPictureIds"] = [];
            for (let item of this.anonymousWealthPictureIds)
                data["anonymousWealthPictureIds"].push(item);
        }
        return data;
    }
}

export interface IPropelleWaitlistEndpointsPushCustomersToHubspot_Request {
    anonymousWealthPictureIds?: string[] | undefined;
}

export class CalculateFutureValue_Response implements ICalculateFutureValue_Response {
    performsWell?: number;
    performsOK?: number;
    performsBadly?: number;

    constructor(data?: ICalculateFutureValue_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.performsWell = _data["performsWell"];
            this.performsOK = _data["performsOK"];
            this.performsBadly = _data["performsBadly"];
        }
    }

    static fromJS(data: any): CalculateFutureValue_Response {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateFutureValue_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["performsWell"] = this.performsWell;
        data["performsOK"] = this.performsOK;
        data["performsBadly"] = this.performsBadly;
        return data;
    }
}

export interface ICalculateFutureValue_Response {
    performsWell?: number;
    performsOK?: number;
    performsBadly?: number;
}

export class CalculateFutureValue_Request implements ICalculateFutureValue_Request {
    prospectiveUserId?: string | undefined;
    initialDeposit?: number | undefined;
    monthlyDeposit?: number | undefined;
    years?: number;
    desiredReturn?: number | undefined;

    constructor(data?: ICalculateFutureValue_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectiveUserId = _data["prospectiveUserId"];
            this.initialDeposit = _data["initialDeposit"];
            this.monthlyDeposit = _data["monthlyDeposit"];
            this.years = _data["years"];
            this.desiredReturn = _data["desiredReturn"];
        }
    }

    static fromJS(data: any): CalculateFutureValue_Request {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateFutureValue_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectiveUserId"] = this.prospectiveUserId;
        data["initialDeposit"] = this.initialDeposit;
        data["monthlyDeposit"] = this.monthlyDeposit;
        data["years"] = this.years;
        data["desiredReturn"] = this.desiredReturn;
        return data;
    }
}

export interface ICalculateFutureValue_Request {
    prospectiveUserId?: string | undefined;
    initialDeposit?: number | undefined;
    monthlyDeposit?: number | undefined;
    years?: number;
    desiredReturn?: number | undefined;
}

export class CreateWealthPicture_Response implements ICreateWealthPicture_Response {
    lumpSumRequired?: number;

    constructor(data?: ICreateWealthPicture_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lumpSumRequired = _data["lumpSumRequired"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Response {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lumpSumRequired"] = this.lumpSumRequired;
        return data;
    }
}

export interface ICreateWealthPicture_Response {
    lumpSumRequired?: number;
}

export class CreateWealthPicture_Request implements ICreateWealthPicture_Request {
    prospectiveUserId?: string | undefined;
    age?: number;
    emailAddress?: string | undefined;
    gender!: CreateWealthPicture_Request_GivenGender;
    financialIndependence?: CreateWealthPicture_Request_FinancialIndependenceRequest | undefined;
    financialSecurity?: CreateWealthPicture_Request_FinancialSecurityRequest | undefined;
    qualityOfLife?: CreateWealthPicture_Request_QualityOfLifeRequest | undefined;
    specificEvent?: CreateWealthPicture_Request_SpecificEventRequest | undefined;
    retirement?: CreateWealthPicture_Request_RetirementRequest | undefined;

    constructor(data?: ICreateWealthPicture_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectiveUserId = _data["prospectiveUserId"];
            this.age = _data["age"];
            this.emailAddress = _data["emailAddress"];
            this.gender = _data["gender"];
            this.financialIndependence = _data["financialIndependence"] ? CreateWealthPicture_Request_FinancialIndependenceRequest.fromJS(_data["financialIndependence"]) : <any>undefined;
            this.financialSecurity = _data["financialSecurity"] ? CreateWealthPicture_Request_FinancialSecurityRequest.fromJS(_data["financialSecurity"]) : <any>undefined;
            this.qualityOfLife = _data["qualityOfLife"] ? CreateWealthPicture_Request_QualityOfLifeRequest.fromJS(_data["qualityOfLife"]) : <any>undefined;
            this.specificEvent = _data["specificEvent"] ? CreateWealthPicture_Request_SpecificEventRequest.fromJS(_data["specificEvent"]) : <any>undefined;
            this.retirement = _data["retirement"] ? CreateWealthPicture_Request_RetirementRequest.fromJS(_data["retirement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectiveUserId"] = this.prospectiveUserId;
        data["age"] = this.age;
        data["emailAddress"] = this.emailAddress;
        data["gender"] = this.gender;
        data["financialIndependence"] = this.financialIndependence ? this.financialIndependence.toJSON() : <any>undefined;
        data["financialSecurity"] = this.financialSecurity ? this.financialSecurity.toJSON() : <any>undefined;
        data["qualityOfLife"] = this.qualityOfLife ? this.qualityOfLife.toJSON() : <any>undefined;
        data["specificEvent"] = this.specificEvent ? this.specificEvent.toJSON() : <any>undefined;
        data["retirement"] = this.retirement ? this.retirement.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateWealthPicture_Request {
    prospectiveUserId?: string | undefined;
    age?: number;
    emailAddress?: string | undefined;
    gender: CreateWealthPicture_Request_GivenGender;
    financialIndependence?: CreateWealthPicture_Request_FinancialIndependenceRequest | undefined;
    financialSecurity?: CreateWealthPicture_Request_FinancialSecurityRequest | undefined;
    qualityOfLife?: CreateWealthPicture_Request_QualityOfLifeRequest | undefined;
    specificEvent?: CreateWealthPicture_Request_SpecificEventRequest | undefined;
    retirement?: CreateWealthPicture_Request_RetirementRequest | undefined;
}

export enum CreateWealthPicture_Request_GivenGender {
    Woman = "Woman",
    TransgenderWoman = "TransgenderWoman",
    Man = "Man",
    TransgenderMan = "TransgenderMan",
    NonBinary = "NonBinary",
    NotListed = "NotListed",
    NotSpecified = "NotSpecified",
}

export class CreateWealthPicture_Request_FinancialIndependenceRequest implements ICreateWealthPicture_Request_FinancialIndependenceRequest {
    percentageWorkReduction?: number;
    years?: number;
    currentGrossSalary?: number;

    constructor(data?: ICreateWealthPicture_Request_FinancialIndependenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentageWorkReduction = _data["percentageWorkReduction"];
            this.years = _data["years"];
            this.currentGrossSalary = _data["currentGrossSalary"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_FinancialIndependenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_FinancialIndependenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentageWorkReduction"] = this.percentageWorkReduction;
        data["years"] = this.years;
        data["currentGrossSalary"] = this.currentGrossSalary;
        return data;
    }
}

export interface ICreateWealthPicture_Request_FinancialIndependenceRequest {
    percentageWorkReduction?: number;
    years?: number;
    currentGrossSalary?: number;
}

export class CreateWealthPicture_Request_FinancialSecurityRequest implements ICreateWealthPicture_Request_FinancialSecurityRequest {
    target?: number;
    years?: number;

    constructor(data?: ICreateWealthPicture_Request_FinancialSecurityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_FinancialSecurityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_FinancialSecurityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["years"] = this.years;
        return data;
    }
}

export interface ICreateWealthPicture_Request_FinancialSecurityRequest {
    target?: number;
    years?: number;
}

export class CreateWealthPicture_Request_QualityOfLifeRequest implements ICreateWealthPicture_Request_QualityOfLifeRequest {
    extraMonthlyIncome?: number;
    years?: number;

    constructor(data?: ICreateWealthPicture_Request_QualityOfLifeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extraMonthlyIncome = _data["extraMonthlyIncome"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_QualityOfLifeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_QualityOfLifeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraMonthlyIncome"] = this.extraMonthlyIncome;
        data["years"] = this.years;
        return data;
    }
}

export interface ICreateWealthPicture_Request_QualityOfLifeRequest {
    extraMonthlyIncome?: number;
    years?: number;
}

export class CreateWealthPicture_Request_SpecificEventRequest implements ICreateWealthPicture_Request_SpecificEventRequest {
    description!: string;
    target?: number;
    years?: number;

    constructor(data?: ICreateWealthPicture_Request_SpecificEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.target = _data["target"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_SpecificEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_SpecificEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["target"] = this.target;
        data["years"] = this.years;
        return data;
    }
}

export interface ICreateWealthPicture_Request_SpecificEventRequest {
    description: string;
    target?: number;
    years?: number;
}

export class CreateWealthPicture_Request_RetirementRequest implements ICreateWealthPicture_Request_RetirementRequest {
    salary?: number;

    constructor(data?: ICreateWealthPicture_Request_RetirementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salary = _data["salary"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_RetirementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_RetirementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salary"] = this.salary;
        return data;
    }
}

export interface ICreateWealthPicture_Request_RetirementRequest {
    salary?: number;
}

export class GetPreviousWealthPicture_Response implements IGetPreviousWealthPicture_Response {
    gender?: PropelleWealthMappingCoreApplicationDomainWealthPictureGender;

    constructor(data?: IGetPreviousWealthPicture_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): GetPreviousWealthPicture_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreviousWealthPicture_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender;
        return data;
    }
}

export interface IGetPreviousWealthPicture_Response {
    gender?: PropelleWealthMappingCoreApplicationDomainWealthPictureGender;
}

export enum PropelleWealthMappingCoreApplicationDomainWealthPictureGender {
    Woman = 1,
    TransgenderWoman = 2,
    Man = 3,
    TransgenderMan = 4,
    NonBinary = 5,
    NotListed = 6,
    NotSpecified = 7,
}

export class GetToolProgress_Response implements IGetToolProgress_Response {
    stage?: GetToolProgress_ToolStage;

    constructor(data?: IGetToolProgress_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): GetToolProgress_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetToolProgress_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        return data;
    }
}

export interface IGetToolProgress_Response {
    stage?: GetToolProgress_ToolStage;
}

export enum GetToolProgress_ToolStage {
    NotStarted = "NotStarted",
    PersonalisedPlan = "PersonalisedPlan",
    Completed = "Completed",
}

export class GetWealthMappingOverview_Response implements IGetWealthMappingOverview_Response {
    futureValueCalculation?: GetWealthMappingOverview_Response_FutureValueCalculationResponse | undefined;
    wealthPicture?: GetWealthMappingOverview_Response_WealthPictureResponse | undefined;

    constructor(data?: IGetWealthMappingOverview_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.futureValueCalculation = _data["futureValueCalculation"] ? GetWealthMappingOverview_Response_FutureValueCalculationResponse.fromJS(_data["futureValueCalculation"]) : <any>undefined;
            this.wealthPicture = _data["wealthPicture"] ? GetWealthMappingOverview_Response_WealthPictureResponse.fromJS(_data["wealthPicture"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["futureValueCalculation"] = this.futureValueCalculation ? this.futureValueCalculation.toJSON() : <any>undefined;
        data["wealthPicture"] = this.wealthPicture ? this.wealthPicture.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response {
    futureValueCalculation?: GetWealthMappingOverview_Response_FutureValueCalculationResponse | undefined;
    wealthPicture?: GetWealthMappingOverview_Response_WealthPictureResponse | undefined;
}

export class GetWealthMappingOverview_Response_FutureValueCalculationResponse implements IGetWealthMappingOverview_Response_FutureValueCalculationResponse {
    inputs?: GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs | undefined;
    outputs?: GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs | undefined;

    constructor(data?: IGetWealthMappingOverview_Response_FutureValueCalculationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputs = _data["inputs"] ? GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs.fromJS(_data["inputs"]) : <any>undefined;
            this.outputs = _data["outputs"] ? GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs.fromJS(_data["outputs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_FutureValueCalculationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_FutureValueCalculationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputs"] = this.inputs ? this.inputs.toJSON() : <any>undefined;
        data["outputs"] = this.outputs ? this.outputs.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_FutureValueCalculationResponse {
    inputs?: GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs | undefined;
    outputs?: GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs | undefined;
}

export class GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs implements IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs {
    initialDeposit?: number | undefined;
    monthlyDeposit?: number | undefined;
    years?: number;
    desiredReturn?: number;

    constructor(data?: IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialDeposit = _data["initialDeposit"];
            this.monthlyDeposit = _data["monthlyDeposit"];
            this.years = _data["years"];
            this.desiredReturn = _data["desiredReturn"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDeposit"] = this.initialDeposit;
        data["monthlyDeposit"] = this.monthlyDeposit;
        data["years"] = this.years;
        data["desiredReturn"] = this.desiredReturn;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs {
    initialDeposit?: number | undefined;
    monthlyDeposit?: number | undefined;
    years?: number;
    desiredReturn?: number;
}

export class GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs implements IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs {
    performsWell?: number;
    performsOK?: number;
    performsBadly?: number;

    constructor(data?: IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.performsWell = _data["performsWell"];
            this.performsOK = _data["performsOK"];
            this.performsBadly = _data["performsBadly"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["performsWell"] = this.performsWell;
        data["performsOK"] = this.performsOK;
        data["performsBadly"] = this.performsBadly;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs {
    performsWell?: number;
    performsOK?: number;
    performsBadly?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse implements IGetWealthMappingOverview_Response_WealthPictureResponse {
    outputs?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs | undefined;
    inputs?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs | undefined;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outputs = _data["outputs"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs.fromJS(_data["outputs"]) : <any>undefined;
            this.inputs = _data["inputs"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs.fromJS(_data["inputs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outputs"] = this.outputs ? this.outputs.toJSON() : <any>undefined;
        data["inputs"] = this.inputs ? this.inputs.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse {
    outputs?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs | undefined;
    inputs?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs | undefined;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs {
    lumpSumRequired?: number;
    goal?: GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse | undefined;
    years?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lumpSumRequired = _data["lumpSumRequired"];
            this.goal = _data["goal"] ? GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse.fromJS(_data["goal"]) : <any>undefined;
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lumpSumRequired"] = this.lumpSumRequired;
        data["goal"] = this.goal ? this.goal.toJSON() : <any>undefined;
        data["years"] = this.years;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs {
    lumpSumRequired?: number;
    goal?: GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse | undefined;
    years?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse implements IGetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse {
    customDescription?: string | undefined;
    type?: GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse_GoalType;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customDescription = _data["customDescription"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customDescription"] = this.customDescription;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse {
    customDescription?: string | undefined;
    type?: GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse_GoalType;
}

export enum GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse_GoalType {
    FinancialIndependence = "FinancialIndependence",
    FinancialSecurity = "FinancialSecurity",
    QualityOfLife = "QualityOfLife",
    SpecificEvent = "SpecificEvent",
    Retirement = "Retirement",
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs {
    age?: number;
    financialIndependence?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs | undefined;
    financialSecurity?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs | undefined;
    qualityOfLife?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs | undefined;
    specificEvent?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs | undefined;
    retirement?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs | undefined;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.financialIndependence = _data["financialIndependence"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs.fromJS(_data["financialIndependence"]) : <any>undefined;
            this.financialSecurity = _data["financialSecurity"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs.fromJS(_data["financialSecurity"]) : <any>undefined;
            this.qualityOfLife = _data["qualityOfLife"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs.fromJS(_data["qualityOfLife"]) : <any>undefined;
            this.specificEvent = _data["specificEvent"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs.fromJS(_data["specificEvent"]) : <any>undefined;
            this.retirement = _data["retirement"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs.fromJS(_data["retirement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["financialIndependence"] = this.financialIndependence ? this.financialIndependence.toJSON() : <any>undefined;
        data["financialSecurity"] = this.financialSecurity ? this.financialSecurity.toJSON() : <any>undefined;
        data["qualityOfLife"] = this.qualityOfLife ? this.qualityOfLife.toJSON() : <any>undefined;
        data["specificEvent"] = this.specificEvent ? this.specificEvent.toJSON() : <any>undefined;
        data["retirement"] = this.retirement ? this.retirement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs {
    age?: number;
    financialIndependence?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs | undefined;
    financialSecurity?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs | undefined;
    qualityOfLife?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs | undefined;
    specificEvent?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs | undefined;
    retirement?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs | undefined;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs {
    years?: number;
    percentageWorkReduction?: number;
    currentGrossSalary?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.years = _data["years"];
            this.percentageWorkReduction = _data["percentageWorkReduction"];
            this.currentGrossSalary = _data["currentGrossSalary"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["years"] = this.years;
        data["percentageWorkReduction"] = this.percentageWorkReduction;
        data["currentGrossSalary"] = this.currentGrossSalary;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs {
    years?: number;
    percentageWorkReduction?: number;
    currentGrossSalary?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs {
    target?: number;
    years?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["years"] = this.years;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs {
    target?: number;
    years?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs {
    extraMonthlyIncome?: number;
    years?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extraMonthlyIncome = _data["extraMonthlyIncome"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraMonthlyIncome"] = this.extraMonthlyIncome;
        data["years"] = this.years;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs {
    extraMonthlyIncome?: number;
    years?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs {
    description?: string | undefined;
    target?: number;
    years?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.target = _data["target"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["target"] = this.target;
        data["years"] = this.years;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs {
    description?: string | undefined;
    target?: number;
    years?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs {
    salary?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salary = _data["salary"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salary"] = this.salary;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs {
    salary?: number;
}

export class NotesCreateUserNote_Response implements INotesCreateUserNote_Response {
    id?: string;
    userId?: string;
    noteText?: string | undefined;
    authorName?: string | undefined;
    isRead?: boolean;
    createdOn?: Date;
    readOn?: Date | undefined;

    constructor(data?: INotesCreateUserNote_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.noteText = _data["noteText"];
            this.authorName = _data["authorName"];
            this.isRead = _data["isRead"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.readOn = _data["readOn"] ? new Date(_data["readOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotesCreateUserNote_Response {
        data = typeof data === 'object' ? data : {};
        let result = new NotesCreateUserNote_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["noteText"] = this.noteText;
        data["authorName"] = this.authorName;
        data["isRead"] = this.isRead;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["readOn"] = this.readOn ? this.readOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotesCreateUserNote_Response {
    id?: string;
    userId?: string;
    noteText?: string | undefined;
    authorName?: string | undefined;
    isRead?: boolean;
    createdOn?: Date;
    readOn?: Date | undefined;
}

export class NotesCreateUserNote_Request_Root implements INotesCreateUserNote_Request_Root {
    userId!: string;
    noteText!: string;
    authorName!: string;

    constructor(data?: INotesCreateUserNote_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.noteText = _data["noteText"];
            this.authorName = _data["authorName"];
        }
    }

    static fromJS(data: any): NotesCreateUserNote_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new NotesCreateUserNote_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["noteText"] = this.noteText;
        data["authorName"] = this.authorName;
        return data;
    }
}

export interface INotesCreateUserNote_Request_Root {
    userId: string;
    noteText: string;
    authorName: string;
}

export class NotesGetUserNotes_Response_Root implements INotesGetUserNotes_Response_Root {
    notes?: NotesGetUserNotes_Response_UserNoteDto[] | undefined;
    totalNotes?: number;
    unreadCount?: number;

    constructor(data?: INotesGetUserNotes_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NotesGetUserNotes_Response_UserNoteDto.fromJS(item));
            }
            this.totalNotes = _data["totalNotes"];
            this.unreadCount = _data["unreadCount"];
        }
    }

    static fromJS(data: any): NotesGetUserNotes_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new NotesGetUserNotes_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["totalNotes"] = this.totalNotes;
        data["unreadCount"] = this.unreadCount;
        return data;
    }
}

export interface INotesGetUserNotes_Response_Root {
    notes?: NotesGetUserNotes_Response_UserNoteDto[] | undefined;
    totalNotes?: number;
    unreadCount?: number;
}

export class NotesGetUserNotes_Response_UserNoteDto implements INotesGetUserNotes_Response_UserNoteDto {
    id?: string;
    noteText?: string | undefined;
    authorName?: string | undefined;
    isRead?: boolean;
    createdOn?: Date;
    readOn?: Date | undefined;

    constructor(data?: INotesGetUserNotes_Response_UserNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.noteText = _data["noteText"];
            this.authorName = _data["authorName"];
            this.isRead = _data["isRead"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.readOn = _data["readOn"] ? new Date(_data["readOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotesGetUserNotes_Response_UserNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotesGetUserNotes_Response_UserNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["noteText"] = this.noteText;
        data["authorName"] = this.authorName;
        data["isRead"] = this.isRead;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["readOn"] = this.readOn ? this.readOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotesGetUserNotes_Response_UserNoteDto {
    id?: string;
    noteText?: string | undefined;
    authorName?: string | undefined;
    isRead?: boolean;
    createdOn?: Date;
    readOn?: Date | undefined;
}

export class NotesGetUserNotes_Request implements INotesGetUserNotes_Request {

    constructor(data?: INotesGetUserNotes_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): NotesGetUserNotes_Request {
        data = typeof data === 'object' ? data : {};
        let result = new NotesGetUserNotes_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface INotesGetUserNotes_Request {
}

export class NotesMarkNoteAsRead_Response implements INotesMarkNoteAsRead_Response {
    id?: string;
    noteText?: string | undefined;
    authorName?: string | undefined;
    isRead?: boolean;
    createdOn?: Date;
    readOn?: Date | undefined;

    constructor(data?: INotesMarkNoteAsRead_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.noteText = _data["noteText"];
            this.authorName = _data["authorName"];
            this.isRead = _data["isRead"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.readOn = _data["readOn"] ? new Date(_data["readOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotesMarkNoteAsRead_Response {
        data = typeof data === 'object' ? data : {};
        let result = new NotesMarkNoteAsRead_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["noteText"] = this.noteText;
        data["authorName"] = this.authorName;
        data["isRead"] = this.isRead;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["readOn"] = this.readOn ? this.readOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotesMarkNoteAsRead_Response {
    id?: string;
    noteText?: string | undefined;
    authorName?: string | undefined;
    isRead?: boolean;
    createdOn?: Date;
    readOn?: Date | undefined;
}

export class NotesMarkNoteAsRead_Request implements INotesMarkNoteAsRead_Request {
    isRead?: boolean;

    constructor(data?: INotesMarkNoteAsRead_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): NotesMarkNoteAsRead_Request {
        data = typeof data === 'object' ? data : {};
        let result = new NotesMarkNoteAsRead_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface INotesMarkNoteAsRead_Request {
    isRead?: boolean;
}

export class InvestmentPlanToolAddUserInvestmentPlan_Request_Root implements IInvestmentPlanToolAddUserInvestmentPlan_Request_Root {
    initialInvestment?: number;
    monthlyInvestment?: number;
    riskLevelName!: string;
    financialGoalId!: string;

    constructor(data?: IInvestmentPlanToolAddUserInvestmentPlan_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialInvestment = _data["initialInvestment"];
            this.monthlyInvestment = _data["monthlyInvestment"];
            this.riskLevelName = _data["riskLevelName"];
            this.financialGoalId = _data["financialGoalId"];
        }
    }

    static fromJS(data: any): InvestmentPlanToolAddUserInvestmentPlan_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentPlanToolAddUserInvestmentPlan_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialInvestment"] = this.initialInvestment;
        data["monthlyInvestment"] = this.monthlyInvestment;
        data["riskLevelName"] = this.riskLevelName;
        data["financialGoalId"] = this.financialGoalId;
        return data;
    }
}

export interface IInvestmentPlanToolAddUserInvestmentPlan_Request_Root {
    initialInvestment?: number;
    monthlyInvestment?: number;
    riskLevelName: string;
    financialGoalId: string;
}

export class InvestmentPlanToolGetUserInvestmentPlanById_Response implements IInvestmentPlanToolGetUserInvestmentPlanById_Response {
    investmentPlan?: PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto | undefined;

    constructor(data?: IInvestmentPlanToolGetUserInvestmentPlanById_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investmentPlan = _data["investmentPlan"] ? PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto.fromJS(_data["investmentPlan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvestmentPlanToolGetUserInvestmentPlanById_Response {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentPlanToolGetUserInvestmentPlanById_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investmentPlan"] = this.investmentPlan ? this.investmentPlan.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvestmentPlanToolGetUserInvestmentPlanById_Response {
    investmentPlan?: PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto | undefined;
}

export class PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto implements IPropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto {
    investmentPlanId?: string;
    initialInvestment?: number;
    monthlyInvestment?: number;
    riskLevelName?: string | undefined;
    monthsToGoalLow?: number;
    monthsToGoalHigh?: number;
    financialGoal?: PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto | undefined;

    constructor(data?: IPropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investmentPlanId = _data["investmentPlanId"];
            this.initialInvestment = _data["initialInvestment"];
            this.monthlyInvestment = _data["monthlyInvestment"];
            this.riskLevelName = _data["riskLevelName"];
            this.monthsToGoalLow = _data["monthsToGoalLow"];
            this.monthsToGoalHigh = _data["monthsToGoalHigh"];
            this.financialGoal = _data["financialGoal"] ? PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto.fromJS(_data["financialGoal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investmentPlanId"] = this.investmentPlanId;
        data["initialInvestment"] = this.initialInvestment;
        data["monthlyInvestment"] = this.monthlyInvestment;
        data["riskLevelName"] = this.riskLevelName;
        data["monthsToGoalLow"] = this.monthsToGoalLow;
        data["monthsToGoalHigh"] = this.monthsToGoalHigh;
        data["financialGoal"] = this.financialGoal ? this.financialGoal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto {
    investmentPlanId?: string;
    initialInvestment?: number;
    monthlyInvestment?: number;
    riskLevelName?: string | undefined;
    monthsToGoalLow?: number;
    monthsToGoalHigh?: number;
    financialGoal?: PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto | undefined;
}

export class PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto implements IPropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto {
    userGoalId?: string;
    name?: string | undefined;
    target?: number;
    current?: number;
    timeline?: number;
    percentage?: number;

    constructor(data?: IPropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGoalId = _data["userGoalId"];
            this.name = _data["name"];
            this.target = _data["target"];
            this.current = _data["current"];
            this.timeline = _data["timeline"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGoalId"] = this.userGoalId;
        data["name"] = this.name;
        data["target"] = this.target;
        data["current"] = this.current;
        data["timeline"] = this.timeline;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IPropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto {
    userGoalId?: string;
    name?: string | undefined;
    target?: number;
    current?: number;
    timeline?: number;
    percentage?: number;
}

export class InvestmentPlanToolGetUserInvestmentPlanById_Request implements IInvestmentPlanToolGetUserInvestmentPlanById_Request {

    constructor(data?: IInvestmentPlanToolGetUserInvestmentPlanById_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): InvestmentPlanToolGetUserInvestmentPlanById_Request {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentPlanToolGetUserInvestmentPlanById_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInvestmentPlanToolGetUserInvestmentPlanById_Request {
}

export class InvestmentPlanToolGetUserInvestmentPlans_Response_Root implements IInvestmentPlanToolGetUserInvestmentPlans_Response_Root {
    investmentPlans?: PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto[] | undefined;
    totalInvestmentPlans?: number;
    hasInvestmentPlans?: boolean;

    constructor(data?: IInvestmentPlanToolGetUserInvestmentPlans_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["investmentPlans"])) {
                this.investmentPlans = [] as any;
                for (let item of _data["investmentPlans"])
                    this.investmentPlans!.push(PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto.fromJS(item));
            }
            this.totalInvestmentPlans = _data["totalInvestmentPlans"];
            this.hasInvestmentPlans = _data["hasInvestmentPlans"];
        }
    }

    static fromJS(data: any): InvestmentPlanToolGetUserInvestmentPlans_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentPlanToolGetUserInvestmentPlans_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.investmentPlans)) {
            data["investmentPlans"] = [];
            for (let item of this.investmentPlans)
                data["investmentPlans"].push(item.toJSON());
        }
        data["totalInvestmentPlans"] = this.totalInvestmentPlans;
        data["hasInvestmentPlans"] = this.hasInvestmentPlans;
        return data;
    }
}

export interface IInvestmentPlanToolGetUserInvestmentPlans_Response_Root {
    investmentPlans?: PropelleWealthMappingCoreApplicationDomainInvestmentPlanToolUserInvestmentPlanDto[] | undefined;
    totalInvestmentPlans?: number;
    hasInvestmentPlans?: boolean;
}

export class FinancialGoalToolAddUserFinancialGoal_Request_Root implements IFinancialGoalToolAddUserFinancialGoal_Request_Root {
    goalId!: string;
    name!: string;
    target?: number;
    current?: number;
    timeline?: number;

    constructor(data?: IFinancialGoalToolAddUserFinancialGoal_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.goalId = _data["goalId"];
            this.name = _data["name"];
            this.target = _data["target"];
            this.current = _data["current"];
            this.timeline = _data["timeline"];
        }
    }

    static fromJS(data: any): FinancialGoalToolAddUserFinancialGoal_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGoalToolAddUserFinancialGoal_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["goalId"] = this.goalId;
        data["name"] = this.name;
        data["target"] = this.target;
        data["current"] = this.current;
        data["timeline"] = this.timeline;
        return data;
    }
}

export interface IFinancialGoalToolAddUserFinancialGoal_Request_Root {
    goalId: string;
    name: string;
    target?: number;
    current?: number;
    timeline?: number;
}

export class FinancialGoalToolDeleteUserFinancialGoal_Request_Root implements IFinancialGoalToolDeleteUserFinancialGoal_Request_Root {

    constructor(data?: IFinancialGoalToolDeleteUserFinancialGoal_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FinancialGoalToolDeleteUserFinancialGoal_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGoalToolDeleteUserFinancialGoal_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IFinancialGoalToolDeleteUserFinancialGoal_Request_Root {
}

export class FinancialGoalToolGetFinancialGoalsList_Response_Root implements IFinancialGoalToolGetFinancialGoalsList_Response_Root {
    goals?: PropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal[] | undefined;

    constructor(data?: IFinancialGoalToolGetFinancialGoalsList_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goals"])) {
                this.goals = [] as any;
                for (let item of _data["goals"])
                    this.goals!.push(PropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinancialGoalToolGetFinancialGoalsList_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGoalToolGetFinancialGoalsList_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goals)) {
            data["goals"] = [];
            for (let item of this.goals)
                data["goals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFinancialGoalToolGetFinancialGoalsList_Response_Root {
    goals?: PropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal[] | undefined;
}

export class PropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal implements IPropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal {
    id?: string;
    name?: string | undefined;
    image?: string | undefined;
    order?: number;

    constructor(data?: IPropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): PropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal {
        data = typeof data === 'object' ? data : {};
        let result = new PropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["order"] = this.order;
        return data;
    }
}

export interface IPropelleWealthMappingCoreApplicationDomainGoalToolFinancialGoal {
    id?: string;
    name?: string | undefined;
    image?: string | undefined;
    order?: number;
}

export class FinancialGoalToolGetUserFinancialGoalById_Response implements IFinancialGoalToolGetUserFinancialGoalById_Response {
    financialGoal?: PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto | undefined;

    constructor(data?: IFinancialGoalToolGetUserFinancialGoalById_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialGoal = _data["financialGoal"] ? PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto.fromJS(_data["financialGoal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FinancialGoalToolGetUserFinancialGoalById_Response {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGoalToolGetUserFinancialGoalById_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialGoal"] = this.financialGoal ? this.financialGoal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFinancialGoalToolGetUserFinancialGoalById_Response {
    financialGoal?: PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto | undefined;
}

export class FinancialGoalToolGetUserFinancialGoalById_Request implements IFinancialGoalToolGetUserFinancialGoalById_Request {

    constructor(data?: IFinancialGoalToolGetUserFinancialGoalById_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FinancialGoalToolGetUserFinancialGoalById_Request {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGoalToolGetUserFinancialGoalById_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IFinancialGoalToolGetUserFinancialGoalById_Request {
}

export class FinancialGoalToolGetUserFinancialGoals_Response_Root implements IFinancialGoalToolGetUserFinancialGoals_Response_Root {
    goals?: PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto[] | undefined;
    totalGoals?: number;
    hasGoals?: boolean;

    constructor(data?: IFinancialGoalToolGetUserFinancialGoals_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goals"])) {
                this.goals = [] as any;
                for (let item of _data["goals"])
                    this.goals!.push(PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto.fromJS(item));
            }
            this.totalGoals = _data["totalGoals"];
            this.hasGoals = _data["hasGoals"];
        }
    }

    static fromJS(data: any): FinancialGoalToolGetUserFinancialGoals_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGoalToolGetUserFinancialGoals_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goals)) {
            data["goals"] = [];
            for (let item of this.goals)
                data["goals"].push(item.toJSON());
        }
        data["totalGoals"] = this.totalGoals;
        data["hasGoals"] = this.hasGoals;
        return data;
    }
}

export interface IFinancialGoalToolGetUserFinancialGoals_Response_Root {
    goals?: PropelleWealthMappingCoreApplicationDomainGoalToolUserFinancialGoalDto[] | undefined;
    totalGoals?: number;
    hasGoals?: boolean;
}

export class FinancialGoalToolUpdateUserFinancialGoal_Request_Root implements IFinancialGoalToolUpdateUserFinancialGoal_Request_Root {
    name?: string | undefined;
    target?: number | undefined;
    current?: number | undefined;
    timeline?: number | undefined;

    constructor(data?: IFinancialGoalToolUpdateUserFinancialGoal_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.target = _data["target"];
            this.current = _data["current"];
            this.timeline = _data["timeline"];
        }
    }

    static fromJS(data: any): FinancialGoalToolUpdateUserFinancialGoal_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGoalToolUpdateUserFinancialGoal_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["target"] = this.target;
        data["current"] = this.current;
        data["timeline"] = this.timeline;
        return data;
    }
}

export interface IFinancialGoalToolUpdateUserFinancialGoal_Request_Root {
    name?: string | undefined;
    target?: number | undefined;
    current?: number | undefined;
    timeline?: number | undefined;
}

export class InvestmentPlanToolUpdateUserInvestmentPlan_Request_Root implements IInvestmentPlanToolUpdateUserInvestmentPlan_Request_Root {
    initialInvestment?: number | undefined;
    monthlyInvestment?: number | undefined;
    riskLevelName?: string | undefined;

    constructor(data?: IInvestmentPlanToolUpdateUserInvestmentPlan_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialInvestment = _data["initialInvestment"];
            this.monthlyInvestment = _data["monthlyInvestment"];
            this.riskLevelName = _data["riskLevelName"];
        }
    }

    static fromJS(data: any): InvestmentPlanToolUpdateUserInvestmentPlan_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentPlanToolUpdateUserInvestmentPlan_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialInvestment"] = this.initialInvestment;
        data["monthlyInvestment"] = this.monthlyInvestment;
        data["riskLevelName"] = this.riskLevelName;
        return data;
    }
}

export interface IInvestmentPlanToolUpdateUserInvestmentPlan_Request_Root {
    initialInvestment?: number | undefined;
    monthlyInvestment?: number | undefined;
    riskLevelName?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}